// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainWhiteButton_container__378rc","label":"PlainWhiteButton_label__88czO"};